import clientAxios from './../../config/axios';

export const getAllData = () => {
  // Backend AWS deprecado; devolvemos respuesta vacía en lugar de llamar.
  return Promise.resolve({ data: { data: {} } } as any);
  // const url = `/dashboards`;
  // return clientAxios.get(url);
};
